var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.25 3.938A3.443 3.443 0 0 1 3.688.5h11.874c1.172 0 2.188 1.016 2.188 2.188v11.25c0 .898-.547 1.64-1.25 1.992v2.695h.313a.95.95 0 0 1 .937.938c0 .546-.43.937-.938.937H3.376C1.617 20.5.25 19.133.25 17.375V3.937zm3.125 12.187c-.703 0-1.25.586-1.25 1.25 0 .703.547 1.25 1.25 1.25h11.25v-2.5H3.375zm-1.25-1.602a3.099 3.099 0 0 1 1.25-.273h12.188a.308.308 0 0 0 .312-.313V2.688a.336.336 0 0 0-.313-.312H3.688c-.899 0-1.563.703-1.563 1.563v10.585zm4.063-9.648h6.875a.95.95 0 0 1 .937.938c0 .546-.43.937-.938.937H6.189c-.547 0-.938-.39-.938-.938 0-.507.39-.937.938-.937zm0 3.125h6.875a.95.95 0 0 1 .937.938c0 .546-.43.937-.938.937H6.189c-.547 0-.938-.39-.938-.938 0-.507.39-.937.938-.937z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon);
export default __webpack_public_path__ + "static/media/DocumentIcon.fc2a932efe103ce61654f988f16a82bb.svg";
export { ForwardRef as ReactComponent };